<template>
  <div>
    <!-- KPI Row -->
    <b-row class="mb-2">
      <b-col v-for="card in kpiCards" :key="card.title" cols="6" md="2">
        <b-card no-body>
          <b-card-body class="text-center">
            <h6 class="text-muted text-uppercase mb-1">{{ card.title }}</h6>
            <h3 class="mb-0">{{ card.value }}</h3>
            <small :class="card.change > 0 ? 'text-success' : 'text-danger'">
              {{ card.change > 0 ? '↑' : '↓' }} {{ Math.abs(card.change) }}%
            </small>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <!-- Campaign Distribution -->
      <b-col md="4" class="mb-2">
        <b-card no-body>
          <b-card-header class="pb-50">
            <h5>Distribution of Campaigns</h5>
          </b-card-header>
          <b-card-body>
            <canvas id="campaignPie"></canvas>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- Performance Marketing -->
      <b-col md="8" class="mb-2">
        <b-card no-body>
          <b-card-header class="pb-50">
            <h5>Performance Marketing</h5>
          </b-card-header>
          <b-card-body>
            <div v-for="perf in performanceBars" :key="perf.label" class="mb-3">
              <small>{{ perf.label }} ({{ perf.value }})</small>
              <b-progress height="8px" :value="perf.percent" :variant="perf.variant"/>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <!-- Campaign Statistics -->
      <b-col md="8" class="mb-2">
        <b-card no-body>
          <b-card-header class="pb-50">
            <h5>Campaign Statistics</h5>
          </b-card-header>
          <b-card-body>
            <b-table
                :items="campaignStats"
                :fields="['status','count','budget']"
                small
                bordered
                responsive
                v-handy-scroll
                class="mb-0"
            />
          </b-card-body>
        </b-card>
      </b-col>

      <!-- Recent Activity -->
      <b-col md="4" class="mb-2">
        <b-card no-body>
          <b-card-header class="pb-50">
            <h5>Recent Activity</h5>
          </b-card-header>
          <b-card-body>
            <ul class="list-unstyled mb-0">
              <li v-for="activity in recentActivity" :key="activity.title" class="mb-2">
                <strong>{{ activity.title }}</strong><br/>
                <small class="text-muted">{{ activity.time }}</small>
              </li>
            </ul>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'CampaignDashboard',
  data() {
    return {
      kpiCards: [
        { title: 'Total Campaigns', value: 4, change: 0 },
        { title: 'Active Campaigns', value: 4, change: 100 },
        { title: 'Leads / FTD', value: '1245 / 167', change: 13.4 },
        { title: 'Marketing Cost', value: '4,782.50 €', change: -2 },
        { title: 'ROI', value: '74.6%', change: 74.6 }
      ],
      performanceBars: [
        { label: 'Conversion Rate', value: '13.4%', percent: 13.4, variant: 'success' },
        { label: 'Cost per Lead', value: '3.84 €', percent: 38, variant: 'info' },
        { label: 'ROI', value: '74.6%', percent: 74.6, variant: 'warning' },
        { label: 'Revenue vs Target', value: '8,350€ / 10,000€', percent: 83.5, variant: 'primary' }
      ],
      campaignStats: [
        { status: 'Active', count: 4, budget: '0.00 €' },
        { status: 'A break', count: 0, budget: '0.00 €' },
        { status: 'Archived', count: 0, budget: '0.00 €' }
      ],
      recentActivity: [
        { title: 'Active Campaign - Titan 52 C', time: '7 days ago' },
        { title: 'Instagram Pro Campaign', time: '7 days ago' },
        { title: 'Test Import Campaign', time: '7 days ago' }
      ]
    };
  },
  mounted() {
    this.renderPie();
  },
  methods: {
    renderPie() {
      const ctx = document.getElementById('campaignPie').getContext('2d');
      new Chart(ctx, {
        type: 'pie',
        data: {
          labels: ['Active', 'A break', 'Archived'],
          datasets: [{
            data: [4, 0, 0],
            backgroundColor: ['#28a745', '#ffc107', '#dc3545']
          }]
        },
        options: {
          responsive: true,
          legend: { labels: { fontColor: this.isDarkSkin ? '#fff' : '#000' } }
        }
      });
    }
  }
};
</script>
